// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"e47eabed","44":"32303234","213":"5ddf5c1c","455":"e4b61f7d","488":"7907dffc","519":"02f8bbc7","740":"9f312e99"}[chunkId] + ".chunk.js";
};